export type CityMapEntry = {
  center: [number, number];
  radius: number;
  primaryLabel: string;
  primaryAddress?: string;
};

// Central configuration for all city pages' NearbyMap defaults.
// Add new cities here to enable the map on their pages automatically.
export const CITY_MAP_CONFIG: Record<string, CityMapEntry> = {
  tokyo: {
    center: [35.681236, 139.767125],
    radius: 500,
    primaryLabel: '东京站 · Tokyo Station',
    primaryAddress: '東京都千代田区丸の内一丁目9-1',
  },
  osaka: {
    center: [34.702485, 135.495951], // Osaka Station area
    radius: 700,
    primaryLabel: '大阪站 · Osaka Station',
    primaryAddress: '大阪府大阪市北区梅田3丁目1-1',
  },
  kyoto: {
    center: [34.985849, 135.758766], // Kyoto Station area
    radius: 700,
    primaryLabel: '京都站 · Kyoto Station',
    primaryAddress: '京都府京都市下京区烏丸通塩小路下ル東塩小路町',
  },
  fuji: {
    center: [35.360556, 138.727778], // Mt. Fuji approx
    radius: 5000,
    primaryLabel: '富士山 · Mt. Fuji',
    primaryAddress: '山梨県・静岡県',
  },
  hongkong: {
    center: [22.281989, 114.158798], // Central, Hong Kong
    radius: 1200,
    primaryLabel: '中環 · Central',
    primaryAddress: '香港中環',
  },
  taipei: {
    center: [25.047708, 121.517055], // Taipei Main Station
    radius: 900,
    primaryLabel: '台北车站 · Taipei Main Station',
    primaryAddress: '臺北市中正區忠孝西路一段49號',
  },
  seoul: {
    center: [37.554722, 126.970833], // Seoul Station
    radius: 900,
    primaryLabel: '首爾站 · Seoul Station',
    primaryAddress: '서울특별시 용산구 청파로 378',
  },
  macau: {
    center: [22.191145, 113.541463], // Senado Square area
    radius: 800,
    primaryLabel: '議事亭前地 · Senado Square',
    primaryAddress: '澳門花王堂區',
  },
  bangkok: {
    center: [13.756331, 100.501765], // Bangkok city center
    radius: 1500,
    primaryLabel: '曼谷市中心 · Bangkok',
    primaryAddress: 'Bangkok, Thailand',
  },
  singapore: {
    center: [1.283333, 103.833333], // Downtown Core
    radius: 1200,
    primaryLabel: '濱海灣 · Marina Bay',
    primaryAddress: 'Downtown Core, Singapore',
  },
  shanghai: {
    center: [31.240, 121.490], // Nanjing East Rd/Bund vicinity
    radius: 1200,
    primaryLabel: '外滩 · The Bund',
    primaryAddress: '上海市黄浦区中山东一路',
  },
  'kuala-lumpur': {
    center: [3.1579, 101.7115], // KLCC area
    radius: 1200,
    primaryLabel: '雙子塔 · KLCC',
    primaryAddress: 'Kuala Lumpur City Centre, Malaysia',
  },
  beijing: {
    center: [39.904211, 116.407395], // Tiananmen/center
    radius: 1500,
    primaryLabel: '天安门 · Tiananmen',
    primaryAddress: '北京市东城区',
  },
};
